import * as Yup from 'yup';
import Translator from '../../../../services/translate-factory';

const T = Translator.create();

export const SolutionCourseAddFormVal = Yup.object().shape({
  course_id: Yup.string().required(),
  start_date: Yup.string().required(),
});
